import _ from 'lodash';

export const filterAsyncRoutesByScopes = (nav, scopes) => {
  const includesAll = scopes.includes('*');
  if (includesAll) {
    return nav;
  }
  return nav
    .map((_item) => {
      if (_item.scopes && _item.scopes.length > 0) {
        if (!scopes.some((scope) => _item.scopes.includes(scope))) {
          return null;
        }
      }
      if (_item.children) {
        const filteredChildren = filterAsyncRoutesByScopes(_item.children, scopes);
        if (filteredChildren.every((child) => child === null)) {
          return null;
        }
        return { ..._item, children: filteredChildren };
      }
      return { ..._item };
    })
    .filter((s) => s !== null);
};

export const filterAsyncRoutesByModules = (nav, modules) => {
  if (!Array.isArray(modules) || modules.includes('*')) return nav;

  return nav
    .map((_item) => {
      if (_.isString(_item.key)) {
        if (!modules.includes(_item.key)) {
          return null;
        }
      }
      if (_item.children) {
        const filteredChildren = filterAsyncRoutesByModules(_item.children, modules);
        if (filteredChildren.every((child) => child === null)) {
          return null;
        }
        return { ..._item, children: filteredChildren };
      }
      return { ..._item };
    })
    .filter((s) => s !== null);
};

export const matchingRoutesToNav = (currentNavBarRoutes = [], currentRoutes = []) => {
  return currentNavBarRoutes.reduce((filteredRoutes, navRoute) => {
    const navBarRouteRef = { ...navRoute };
    const isBypass = navBarRouteRef.bypass === true;
    const isItem = navBarRouteRef.type === 'item';
    const isGroupOrCollapse = ['group', 'collapse'].includes(navBarRouteRef.type);

    if (Array.isArray(navBarRouteRef.children)) {
      navBarRouteRef.children = matchingRoutesToNav(navBarRouteRef.children, currentRoutes);
    }

    if (isItem && isBypass) {
      filteredRoutes.push(navBarRouteRef);
      return filteredRoutes;
    }

    if (isItem) {
      const isRouteMatched = checkIfRouteMatches(currentRoutes, navBarRouteRef.id);

      if (isRouteMatched) {
        filteredRoutes.push(navBarRouteRef);
      }

      return filteredRoutes;
    }

    if (isGroupOrCollapse && isBypass) {
      filteredRoutes.push(navBarRouteRef);
      return filteredRoutes;
    }

    if (isGroupOrCollapse) {
      if (navBarRouteRef.children?.length > 0) {
        filteredRoutes.push(navBarRouteRef);
      }

      return filteredRoutes;
    }

    return filteredRoutes;
  }, []);
};

// eslint-disable-next-line default-param-last
const checkIfRouteMatches = (routes = [], navRouteId) => {
  return routes.some((route) => {
    if (route.id === navRouteId) {
      return true;
    }

    if (Array.isArray(route.children)) {
      return checkIfRouteMatches(route.children, navRouteId);
    }

    return false;
  });
};

// ----- Extracted from Wd core --------

export const setRoutes = (config) => {
  let routes = [...config.routes];

  routes = routes.map((route) => {
    const settings = _.merge({}, config.settings, route.settings);
    let scopes;
    if (config.scopes) {
      scopes = config.scopes;
    } else if (route.scopes) {
      scopes = route.scopes;
    } else {
      scopes = undefined;
    }

    return {
      ...route,
      settings,
      scopes,
    };
  });

  return [...routes];
};

export const generateRoutesFromAsyncList = (asyncRoutes) => {
  let allRoutes = [];
  asyncRoutes.forEach((asyncRoute) => {
    allRoutes = [...allRoutes, ...setRoutes(asyncRoute)];
  });
  return allRoutes;
};
